var ɵ0 = function (config) { return config.oicdClientSettings; };
var AuthenticationModule = /** @class */ (function () {
    function AuthenticationModule() {
    }
    return AuthenticationModule;
}());
export { AuthenticationModule };
export { ɵ0 };
